// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    RECEIVED_BOOKMARK: null,
    RECEIVED_BOOKMARKS: null,

    BOOKMARK_DELETED: null,
});
